// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__152U4","label":"SetPasswdForm_label__3HsE6"};